export const Configuration = {
  
    FRONT_BASEURL: process.env.REACT_APP_FRONT_BASEURL,
    BACK_BASEURL: process.env.REACT_APP_BACK_BASEURL?.endsWith('/') ? process.env.REACT_APP_BACK_BASEURL : process.env.REACT_APP_BACK_BASEURL + '/',    

    industrie2: "/medis",
    industrie3: "/neapolis",
    industrie2sans: "medis",
    industrie3sans: "neapolis",

};
export default Configuration;
